import React, { FC, memo } from "react";

import { SocAuthCallbackScreen } from "../";

export const AccountGoogleRedirect: FC = memo(() => <SocAuthCallbackScreen network="google" />);
